import { ISpinnerStyles } from '@fluentui/react';
import { Environment, SourceApps } from '../../../models/constants/constants';
import { getGetHelpCustomStyles } from './getHelpIntentGraphStyles';
import { IContactUsCurrentTheme } from './theme.model';

export const customStyles = () => {
  const contentStyle = {
    width: '80%',
    margin: '10px',
    marginTop: '0px',
    '&  *': {
      marginTop: '5px',
      marginBottom: '0',
    },
    '& a': {
      color: '#006cb4 !important',
      '& [role=button]' : {
        backgroundColor: 'rgb(51 122 183)',
        border: '1px solid black',
        borderRadius: '2px',
        color: 'white !important',
        cursor: 'pointer',
        display: 'inline-block',
        fontWeight: '400',
        padding: '6px 20px'
      },
      '& :hover[role=button]' : {
        backgroundColor: 'rgb(40 96 144)'
      },
      '& :active[role=button]' : {
        backgroundColor: 'rgb(32 77 116)',
        borderColor: 'rgb(18 43 64)'
      }
    },
    '& ol': {
      padding: '0px 0px 0px 20px',
    },
    '& ul': {
      padding: '0px 0px 0px 20px',
    },
    '& li': {
      padding: '13px 0px 0px 0px',
    },
    '& h2': {
      fontSize: '1.75em',
      fontWeight: '300',
      lineHeight: '1.33',
      marginTop: '48px',
      marginBottom: '20px',
    },
    '@media (min-width: 720px)' : {
      'div[data-bi-view^=\'Grid \'] > div' : {
        display: 'flex',
        flexDirection: 'row',
        '> div[data-bi-compnm]' : {
          padding: '20px 40px 30px 0'
        }
      }
    }
  };
  return {
    hostDiv: {
      root: {
        marginLeft: '-10px',
        fontSize: '14px',
        fontFamily:
          "'Segoe UI','Segoe UI Web','wf_segoe-ui_normal','Helvetica Neue','BBAlpha Sans','S60 Sans',Arial,sans-serif",
        lineHeight: 'normal',
        marginTop: '15px',
      },
    },
    nodeList: {},
    nodeHeader: {},
    textFieldSpinner: {
      root: {
        width: '80%',
        marginTop: '10px',
      },
    },
    node: {
      content: contentStyle,
      contentTitle: {
        boxSizing: 'border-box',
        fontSize: '19px',
        fontWeight: '600',
        margin: '0px',
        width: '80%',
        padding: '0 0 0 9px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
    },
    choice: {
      container: {
        width: '100%',
        overflow: 'hidden' as const,
        marginBottom: '5px',
      },
      listContainer: {
        marginBottom: '10px',
        marginLeft: '10px',
      },
      btnLabel: {
        overflow: 'hidden' as const,
        height: '100%',
        width: '100%',
        '& > *': {
          overflow: 'hidden' as const,
          'overflow-wrap': 'break-word',
        },
      },
      choiceBtn: {
        root: {
          background: '#f3f3f3',
          marginRight: '16px',
          marginTop: '16px',
          minWidth: '52px',
          minHeight: '42px',
          width: '100%',
          border: 'none',
          color: '#000',
        },
        rootChecked: {
          background: '#337ab7',
          marginRight: '16px',
          marginTop: '16px',
          minWidth: '52px',
          minHeight: '42px',
          width: '100%',
          border: '1px solid black',
        },
        label: {
          overflow: 'hidden' as const,
          height: '100%',
          width: '93%',
          '& > *': {
            overflow: 'hidden' as const,
            'overflow-wrap': 'break-word',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
          'overflow-wrap': 'break-word',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          minHeight: '24px !important',
        },
        labelChecked: {
          overflow: 'hidden' as const,
          height: '100%',
          width: '93%',
          '& > *': {
            overflow: 'hidden' as const,
            'overflow-wrap': 'break-word',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
          'overflow-wrap': 'break-word',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          minHeight: '24px !important',
          color: 'white',
        },
        textContainer: {
          textAlign: 'left',
          textOverflow: 'ellipsis',
          overflow: 'hidden' as const,
          '& > span': {
            minHeight: '18px !important',
          },
        },
      },
      editIcon: {
        cursor: 'pointer',
        float: 'right',
      },
      choicesList: {
        margin: '0 0 10px 10px',
      },
    },
    safNode: {},
    dafSpinner: {},
    safActionNode: {
      label: {
        fontWeight: '600',
        overflow: 'hidden' as const,
        width: '100%',
        textAlign: 'left',
        '& > *': {
          fontWeight: '600',
          overflow: 'hidden',
          'overflow-wrap': 'break-word',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          textAlign: 'left',
        },
      },
      safContainer: {
        margin: '10px',
        marginTop: 0,
      },
      completedIcon: {
        color: 'white',
        cursor: 'pointer',
        float: 'right',
      },
      inlineDiagnostics: {
        contentContainer: {
          marginBottom: '16px',
          width: '80%',
        },
        diagnostcForm: {
          button: {
            root: {
              background: '#337ab7',
              marginRight: '16px',
              marginTop: '16px',
              border: '1px solid black',
            },
            rootDisabled: {
              backgroundColor: '#337ab7',
              borderColor: '1px solid #000',
              color: '#fff',
              opacity: '.65',
              boxShadow: 'none',
              cursor: 'not-allowed',
              padding: '6px 16px',
              fontSize: '14px',
            },
          },
          common: {
            contentContainer: {
              marginBottom: '16px',
              width: '80%',
            },
            sectionHeader: {
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '20px',
            },
            title: {
              fontSize: '16px',
              fontWeight: '600',
            },
          },
        },
      },
    },
    inputNode: {
      textField: {
        root: contentStyle,
      },
      button: {
        root: {
          margin: '10px',
          marginTop: '16px',
          background: '#337ab7',
          border: '1px solid black',
        },
        rootDisabled: {
          backgroundColor: '#337ab7',
          borderColor: '1px solid #000',
          color: '#fff',
          opacity: '.65',
          boxShadow: 'none',
          cursor: 'not-allowed',
          padding: '6px 16px',
        },
      },
    },
    mainHeader: {
      headerRootDiv: {
        color: 'black',
        width: '90%',
        fontSize: '16px',
        fontWeight: 'bold !important',
        margin: '0px 10px',
        overflow: 'hidden' as const,
        overflowWrap: 'break-word',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
        marginBottom: '16px',
        '& > *': {
          width: '100%',
          fontSize: '16px',
          color: 'black',
          fontWeight: 'bold !important',
          overflow: 'hidden' as const,
          overflowWrap: 'break-word',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          display: 'block',
        },
      },
    },
  };
};

export const getWACOrInAppBaseCustomStyles = () => {
  const styles = customStyles();
  styles.choice.choiceBtn.label['display'] = 'inline';
  styles.choice.choiceBtn.labelChecked['display'] = 'inline';
  styles.nodeList['listContainer'] = {
    width: '100%',
  };
  styles.node.content.width = '100%';
  styles.node.content['padding'] = '5px';
  styles.inputNode.textField.root.width = '100%';
  styles.inputNode.textField.root['padding'] = '5px';
  styles.node.contentTitle.width = '100%';
  styles.choice.choiceBtn.root.width = '100%';
  styles.choice.choiceBtn.rootChecked.width = '100%';
  return styles;
};

export const getInAppCustomStyles = (theme: IContactUsCurrentTheme) => () => {
  const styles = getWACOrInAppBaseCustomStyles();
  styles.hostDiv.root['color'] = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.labelChecked.color = theme.palette.neutralPrimary;
  styles.safActionNode.completedIcon.color = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.root.background = 'white';
  styles.choice.choiceBtn['rootHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn['rootCheckedHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn.rootChecked.background = theme.palette.themeTertiary;
  styles.choice.choiceBtn.rootChecked['color'] = theme.palette.neutralPrimary;
  // input node button
  styles.inputNode.button['labelChecked'] = {
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.button.root.background = theme.palette.themePrimary;
  styles.inputNode.button.root['marginRight'] = '16px';
  styles.inputNode.button['rootHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootCheckedHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootChecked'] = {
    background: theme.palette.themePrimary,
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.textField.root['& a']['color'] = theme.semanticColors.link;
  styles.inputNode.textField.root.width = '90%';
  styles.node['question'] = {
    color: theme.palette.neutralPrimary,
    width: '80%',
    margin: '10px',
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 'bold',
  };
  styles.node.content['& a']['color'] = theme.semanticColors.link;
  return styles;
};

export const getTeamsCustomStyles = (theme: IContactUsCurrentTheme) => () => {
  const styles = customStyles();
  styles.hostDiv.root['color'] = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.labelChecked.color = theme.palette.neutralPrimary;
  styles.safActionNode.completedIcon.color = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.root.background = 'white';
  styles.choice.choiceBtn['rootHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn['rootCheckedHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn.rootChecked.background = theme.palette.themeTertiary;
  styles.choice.choiceBtn.rootChecked['color'] = theme.palette.neutralPrimary;
  // input node button
  styles.inputNode.button['labelChecked'] = {
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.button.root.background = theme.palette.themePrimary;
  styles.inputNode.button['rootHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootCheckedHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootChecked'] = {
    background: theme.palette.themePrimary,
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.textField.root['& a']['color'] = `${theme.semanticColors.link} !important`;
  styles.node['question'] = {
    color: theme.palette.neutralPrimary,
    width: '80%',
    margin: '10px',
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 'bold',
  };
  styles.node.content['& a']['color'] = `${theme.semanticColors.link} !important`;
  return styles;
};

export const getSurfaceAppCustomStyles = (theme: IContactUsCurrentTheme) => () => {
  const styles = customStyles();
  styles.hostDiv.root['color'] = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.labelChecked.color = theme.palette.neutralPrimary;
  styles.safActionNode.completedIcon.color = theme.palette.neutralPrimary;
  styles.choice.choiceBtn.root.background = theme.palette.neutralQuaternaryAlt;
  styles.choice.choiceBtn.root.color = theme.palette.neutralPrimary;
  styles.choice.choiceBtn['rootHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn['rootCheckedHovered'] = {
    'background': theme.palette.themeTertiary,
    'color': theme.palette.neutralPrimary,
  };
  styles.choice.choiceBtn.rootChecked.background = theme.palette.themeTertiary;
  styles.choice.choiceBtn.rootChecked['color'] = theme.palette.neutralPrimary;
  // input node button
  styles.inputNode.button['labelChecked'] = {
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.button.root.background = theme.palette.themePrimary;
  styles.inputNode.button['rootHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootCheckedHovered'] = {
    'background': theme.palette.themePrimary,
    'color': theme.palette.neutralPrimary,
  };
  styles.inputNode.button['rootChecked'] = {
    background: theme.palette.themePrimary,
    color: theme.palette.neutralPrimary,
  };
  styles.inputNode.textField.root['& a']['color'] = `${theme.semanticColors.link} !important`;
  styles.node['question'] = {
    color: theme.palette.neutralPrimary,
    width: '80%',
    margin: '10px',
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 'bold',
  };
  styles.node.content['& a']['color'] = `${theme.semanticColors.link}`;
  return styles;
};

export const getSurfaceWebCustomStyles = (theme: IContactUsCurrentTheme) => () => {
  const styles = customStyles();
  styles.node.contentTitle.fontSize = '2.3em';
  styles.node.contentTitle.fontWeight = '300';
  styles.node.contentTitle.width = '100%';
  styles.node.contentTitle.margin = '10px 0 20px 0';
  styles.node.contentTitle.whiteSpace = 'normal';
  return styles;
}

export const getHostStyles = (theme: IContactUsCurrentTheme, environment: Environment, sourceApp: SourceApps) => {
  if (sourceApp) {
    switch (sourceApp.toLowerCase()) {
      case SourceApps.Teams:
      case SourceApps.Teams2:
      case SourceApps.TeamsAdmin:
      case SourceApps.TeamsAdmin2:
        return getTeamsCustomStyles(theme);
      case SourceApps.SurfaceApp:
      case SourceApps.SurfaceApp2:
        return getSurfaceAppCustomStyles(theme);
      case SourceApps.SurfaceWeb:
        return getSurfaceWebCustomStyles(theme);
      default:
        break;
    }
  }
  switch (environment) {
    case Environment.agavePane:
      return getWACOrInAppBaseCustomStyles;
    case Environment.nonAgavePane:
      return getInAppCustomStyles(theme);
    case Environment.GetHelp:
      return getGetHelpCustomStyles(theme);
    default:
      return customStyles;
  }
};

export const getSpinnerStyles = (): Partial<ISpinnerStyles> => {
  return {
    root: {
      marginTop: '10px',
      width: '80%',
    },
  };
};
